import { Button } from "@/components/ui/button";
import { DialogClose, DialogFooter } from "@/components/ui/dialog";
import { useCreateWorkspaceInvite } from "@/queries/workspace-invites";
import { WorkspaceInviteFormValues } from "@/schemas/workspace-invite";
import { useFormContext } from "react-hook-form";

interface SubmitProps {
  onSuccess: () => void;
}

const Submit = ({ onSuccess }: SubmitProps) => {
  const createWorkspaceInvite = useCreateWorkspaceInvite();
  const form = useFormContext<WorkspaceInviteFormValues>();
  const count = form.watch("emails")?.length ?? 0;

  let invite = "Invite";
  if (count > 1) {
    invite = `${invite} ${count} people`;
  } else if (count > 0) {
    invite = `${invite} ${count} person`;
  }

  const handleClick = form.handleSubmit(
    (data: WorkspaceInviteFormValues) => {
      createWorkspaceInvite.mutate(data, {
        onSuccess: () => {
          onSuccess();
        },
      });
    },
    (errors) => {
      console.error("Form validation errors:", errors);
    },
  );

  return (
    <DialogFooter>
      <DialogClose>
        <Button variant="secondary">Cancel</Button>
      </DialogClose>
      <Button
        onClick={handleClick}
        disabled={
          !form.formState.isValid ||
          count === 0 ||
          createWorkspaceInvite.isLoading
        }
        isLoading={createWorkspaceInvite.isLoading}
      >
        {createWorkspaceInvite.isLoading ? "Sending..." : invite}
      </Button>
    </DialogFooter>
  );
};

export default Submit;
